import { render, staticRenderFns } from "./RestoreView.vue?vue&type=template&id=b7b96d54"
import script from "./RestoreView.vue?vue&type=script&lang=js"
export * from "./RestoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports